<template lang="pug">
  server-data(
    ref="list"
    :method="$api.exports.list"
    :query="query"
    v-slot="{ serverData, loading }"
  )
    data-wrapper(
      :loading="loading"
      :skeleton-items-count="6"
      :has-items="!!serverData.length"
      skeleton-type="paragraph"
      :colsProps="{ cols: 12, md: 12, sm: 12, xl: 12 }"
    )
      template(#no-data)
        span Нет ни одной выгрузки
      template(#default)
        v-sheet.grey.lighten-4.px-2.pb-2
          .d-flex.align-end.py-2
            .caption.px-2.mb-2 История выгрузки:
            v-spacer
            v-btn.mr-2(
              color="primary"
              small depressed outlined
              @click="$refs.list.init()"
            )
              v-icon(left) mdi-reload
              span Обновить
          v-list.grey.lighten-4.overflow-auto.scroll.scroll-padding.py-0.relative(
            flat max-height="400px"
          )
            div(v-for="(item, idx) in serverData")
              .pt-3(
                v-if="idx === 0 || !checkIsSameDay(item, serverData[idx-1])"
                :key="`${item.id}-date`"
              )
                .d-flex.grey--text.text--darken-2.px-2.align-center
                  span.text-body-1 {{ item.created_at | dp('dd MMMM')}}
                  v-divider.mx-6.mt-1
                  .text-body-2 {{ item.created_at | dp('yyyy')}}

              v-list-item.my-2.mr-1.white(:key="item.id")
                v-list-item-content
                  .d-flex.pb-2
                    tooltip-wrap(
                      :text="STATUSES_DATA[item.status].text"
                    )
                    v-icon.mr-2(
                      size="20"
                      :color="STATUSES_DATA[item.status].color"
                    ) {{ STATUSES_DATA[item.status].icon }}
                    span.text-body-2.pt-1: strong {{ date(item) }}
                  v-list-item-title.text-body-1.secondary--text.pl-1 {{TYPES_DATA[item.type].name}}
                v-list-item-action(v-if="item.status === STATUSES.success")
                  tooltip-wrap(text="Скачать")
                    v-btn(fab color="primary" small text :href="item.document.url" download)
                      v-icon mdi-download
                v-list-item-action(v-if="item.status === STATUSES.error")
                  v-btn(color="error" text) Произошла ошибка

          .d-flex(style="position: sticky; bottom: 0; z-index: 1").pt-2
            slot(name="actions")
</template>
<script>
import { isSameDay } from 'date-fns';

const STATUSES = {
  new: 1,
  process: 2,
  success: 3,
  error: 4,
};

const STATUSES_DATA = {
  [STATUSES.new]: {
    text: 'Новая',
    color: 'grey',
    icon: 'mdi-clock-outline',
  },
  [STATUSES.process]: {
    text: 'В процессе',
    color: 'primary',
    icon: 'mdi-progress-upload',
  },
  [STATUSES.success]: {
    text: 'Завешена',
    color: 'success',
    icon: 'mdi-check-circle-outline',
  },
  [STATUSES.error]: {
    text: 'Ошибка',
    color: 'error',
    icon: 'mdi-alert-circle-outline',
  },
};

const TYPES = {
  roster: 1,
  journal: 2,
};

const TYPES_DATA = {
  [TYPES.roster]: {
    name: 'Выгрузка ФИС ФРДО',
    fileType: 'xlsx',
  },
  [TYPES.journal]: {
    name: 'Журнал выдачи удостоверений',
    fileType: 'docx',
  },
};

export default {
  data() {
    return {
      STATUSES,
      TYPES_DATA,
      STATUSES_DATA,
      query: {
        sort: '-id',
        expand: 'document',
      },
    };
  },
  methods: {
    date(item) {
      return this.$dp.dateprintDefault(item.created_at).split(' ')[1];
    },
    checkIsSameDay(item, prevItem) {
      console.log(item.created_at, prevItem.created_at);
      return isSameDay(new Date(item.created_at), new Date(prevItem.created_at));
    },
  },
};
</script>
